import Footer from '@/features/app/components/footer';
import Header from '@/features/app/components/header';
import useAdminSettingsQuery from '@/features/app/queries/useAdminSettingsQuery';
import { Loader } from '@thisisdmg/tirecloud-patterns';
import { Skeleton } from 'antd';
import { matchPath, Outlet, useMatches } from 'react-router-dom';
import Error404Page from '@/features/errors/routes/404';
import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';

function useIsPageEnabled() {
  const { isLoading } = useAdminSettingsQuery();
  const featureFlags = useFeatureFlags();
  const routeMatches = useMatches();

  // admin page check
  for (const adminRule of [
    {
      url: '/admin/analytics',
      flag: featureFlags.page.admin.analytics.enabled,
    },
    {
      url: '/admin/users',
      flag: featureFlags.page.admin.userManagement.enabled,
    },
    {
      url: '/admin/dashboard-settings',
      flag: featureFlags.page.admin.dashboardSettings.enabled,
    },
    {
      url: '/admin/email-settings',
      flag: featureFlags.page.admin.emailSettings.enabled,
    },
  ]) {
    if (
      routeMatches.find((match) =>
        matchPath({ path: adminRule.url, end: false }, match.pathname)
      ) &&
      adminRule.flag !== true
    )
      return [isLoading, false];
  }

  return [isLoading, true];
}

function MainContent() {
  const [isLoading, isPageEnabled] = useIsPageEnabled();
  const featureFlags = useFeatureFlags();

  return isLoading ? (
    featureFlags.page.misc.useSkeletonLoader ? (
      <Skeleton active />
    ) : (
      <Loader fullScreen />
    )
  ) : isPageEnabled ? (
    <Outlet />
  ) : (
    <Error404Page />
  );
}

function RootLayout() {
  const isIFrame = window !== window.parent;

  if (isIFrame) {
    return <MainContent />;
  }

  return (
    <>
      <Header />
      <div className="tw:min-h-[calc(100vh-50px-92px)]">
        <MainContent />
      </div>
      <Footer />
    </>
  );
}

export default RootLayout;
